import React, { useEffect, useRef, useState } from 'react'
import { motion } from "framer-motion"
import { Parallax, useParallax } from 'react-scroll-parallax';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

export default function Home() {


    useEffect(() => {
        const script = document.createElement('script');
        script.charset = 'utf-8';
        script.type = 'text/javascript';
        script.src = 'https://js.hsforms.net/forms/embed/v2.js';
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
            window.hbspt.forms.create({
                portalId: '7585485',
                formId: 'b472ef23-d7aa-4909-83a9-e8f71e0f26f9',
                target: '#hubspot-form-container',
            });
        };

        return () => {
            document.body.removeChild(script);
        };
    }, []);


    return (
        <>
            <Helmet prioritizeSeoTags={true}>
                <meta http-equiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Contact Us | Winklix</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta
                    name="description"
                    content="Contact winklix to get your digittal transformation service"
                />
            </Helmet>

            <div className='contact-section padding_top_contact bottom'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-3'>
                            <div className='contact-left top'>
                                <div className='contact_left_first'>
                                    <div className='contact_left-icons'><img src={require('../assets/images/fast.webp')} alt='' /></div>
                                    <div className='contact_left-content'>
                                        <span><strong>Quick response</strong></span>
                                        <p className='prose-sm'>We typically respond within one hour during business days to sign the NDA and schedule a discussion.</p>
                                    </div>
                                </div>
                                <div className='contact_left_first mt-4'>
                                    <div className='contact_left-icons'><img src={require('../assets/images/personalization.webp')} alt='' /></div>
                                    <div className='contact_left-content'>
                                        <span><strong>Personalized approach</strong></span>
                                        <p className='prose-sm'>You’ll work directly with specialists who have expertise in your specific domain.</p>
                                    </div>
                                </div>
                                <div className='contact_left_first mt-4'>
                                    <div className='contact_left-icons'><img src={require('../assets/images/no-pressure.webp')} alt='' /></div>
                                    <div className='contact_left-content'>
                                        <span><strong>No pressure</strong></span>
                                        <p className='prose-sm'>We’re here to understand your needs and offer guidance — whenever you're ready to take the next step.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-7 contact_margin'>
                            <div className='contact_form_middle'>
                                <div className='contact_about'>
                                    <h3>Let's discuss your needs!</h3>
                                    <p className='prose-md'>Have a question for our specialists, want to discuss your project, or learn more about our expertise? Simply submit your request using the form below!</p>
                                </div>
                                <div className='contact_form'>
                                    <div id="hubspot-form-container"></div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-2 contact-right-bg'>
                            <div className='contact_right'>
                                <span><strong>Our Contacts</strong></span>
                                <div className='contact-social'>
                                    <div className='call_1'>
                                        <Link to="tel:+13477462125">
                                            <img src={require('../assets/images/call-us.webp')} alt="" />
                                            &nbsp;<span>+1-(347) 746 2125</span>
                                        </Link>
                                    </div>
                                    <div className='call_1'>
                                        <Link to="tel:+13477462125">
                                            <img src={require('../assets/images/call-us.webp')} alt="" />
                                            &nbsp;<span>+44 74183 43214</span>
                                        </Link>
                                    </div>
                                    <div className='call_1'>
                                        <Link to="tel:+13477462125">
                                            <img src={require('../assets/images/call-us.webp')} alt="" />
                                            &nbsp;<span>+91 8882313131</span>
                                        </Link>
                                    </div>
                                    <div className='call_2 mt-4'>
                                        <Link to="mailto:info@winklix.com">
                                            <img src={require('../assets/images/mail-us.webp')} alt="" />
                                            &nbsp;info@winklix.com
                                        </Link>
                                    </div>
                                    <div className='call_3 mt-4'>
                                        <Link to="https://wa.me/13477462125" target="_blank">
                                            <img src={require('../assets/images/whtsp.webp')} alt="" />
                                            &nbsp;+1-(347) 746 2125
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className='contact_right'>
                                <span><strong>Our Blogs</strong></span>
                                <div className='contact-social'>
                                    <div className='call_1'>
                                        <Link to="https://www.winklix.com/blog/" target='_blank'>
                                            <img src={require('../assets/images/voice.webp')} alt="" />
                                            &nbsp;<span>Read our blog</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className='contact_right'>
                                <span><strong>Join our team</strong></span>
                                <div className='contact-social'>
                                    <div className='call_1'>
                                        <Link to="/career">
                                            <img src={require('../assets/images/messenger-cv.webp')} alt="" />
                                            &nbsp;<span>Upload your CV</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className='contact_right'>
                                <span><strong>Social media</strong></span>
                                <div className='contact-social'>
                                    <div className='social_midea'>
                                        <Link to="https://www.linkedin.com/company/winklix/?originalSubdomain=in" target="_blank"><img src={require('../assets/images/linkedin.webp')} alt='' /></Link>
                                        <Link to="https://www.youtube.com/channel/UCS9W-DHO95H39gavX8ICcdA" target="_blank"><img src={require('../assets/images/youtube.webp')} alt='' /></Link>
                                        <Link to="https://x.com/winklix?mx=2" target="_blank"><img src={require('../assets/images/twitter.webp')} alt='' /></Link>
                                        <Link to="https://www.facebook.com/Winklix/" target="_blank"><img src={require('../assets/images/facebook.webp')} alt='' /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='client-says'>
                <div className='container'>
                    <h2 className='heading1 text-center'>Our Clients</h2>
                    <div className='row top'>
                        <Swiper
                            breakpoints={{
                                425: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                },
                                640: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                },
                                768: {
                                    slidesPerView: 4,
                                    spaceBetween: 30,
                                },
                                1024: {
                                    slidesPerView: 6,
                                    spaceBetween: 30,
                                },
                                1440: {
                                    slidesPerView: 6,
                                    spaceBetween: 30,
                                },
                            }}
                            autoplay={{
                                delay: 3000,
                                disableOnInteraction: false,
                            }}
                            pagination={{
                                clickable: true,
                            }}
                            modules={[Pagination, Autoplay]}
                            className="testimonialSwiper-client"
                        >
                            <SwiperSlide>
                                <div className='clients-logo-img-slide'>
                                    <img src={require('../assets/images/client/client-1.webp')} alt='winklix contact us' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='clients-logo-img-slide'>
                                    <img src={require('../assets/images/client/client-2.webp')} alt='winklix contact us' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='clients-logo-img-slide'>
                                    <img src={require('../assets/images/client/client-3.webp')} alt='winklix contact us' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='clients-logo-img-slide'>
                                    <img src={require('../assets/images/client/client-4.webp')} alt='winklix contact us' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='clients-logo-img-slide'>
                                    <img src={require('../assets/images/client/client-5.webp')} alt='winklix contact us' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='clients-logo-img-slide'>
                                    <img src={require('../assets/images/client/client-6.webp')} alt='winklix contact us' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='clients-logo-img-slide'>
                                    <img src={require('../assets/images/client/client-7.webp')} alt='winklix contact us' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='clients-logo-img-slide'>
                                    <img src={require('../assets/images/client/client-8.webp')} alt='winklix contact us' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='clients-logo-img-slide'>
                                    <img src={require('../assets/images/client/client-9.webp')} alt='winklix contact us' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='clients-logo-img-slide'>
                                    <img src={require('../assets/images/client/client-10.webp')} alt='winklix contact us' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='clients-logo-img-slide'>
                                    <img src={require('../assets/images/client/client-11.webp')} alt='winklix contact us' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='clients-logo-img-slide'>
                                    <img src={require('../assets/images/client/client-12.webp')} alt='winklix contact us' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='clients-logo-img-slide'>
                                    <img src={require('../assets/images/client/client-13.webp')} alt='winklix contact us' />
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </div>

            <div className='client-says top'>
                <div className='container'>
                    <h2 className='heading1 text-center'>What Our Clients Say's</h2>
                    <div className='row top'>
                        <Swiper
                            breakpoints={{
                                640: {
                                    slidesPerView: 1,
                                    spaceBetween: 10,
                                },
                                768: {
                                    slidesPerView: 1,
                                    spaceBetween: 30,
                                },
                                1024: {
                                    slidesPerView: 2,
                                    spaceBetween: 30,
                                },
                                1440: {
                                    slidesPerView: 3,
                                    spaceBetween: 30,
                                },
                            }}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            pagination={{
                                clickable: true,
                            }}
                            modules={[Pagination, Autoplay]}
                            className="testimonialSwiper-client"
                        >
                            <SwiperSlide className="col-lg-4 ">
                                <div className='client-say-item'>
                                    <iframe
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen
                                        class="lazy entered loaded"
                                        data-src="https://www.youtube.com/embed/vyFlrXqWKc8"
                                        frameborder="0"
                                        height="450"
                                        scrolling="no"
                                        width="100%"
                                        src="https://www.youtube.com/embed/vyFlrXqWKc8"
                                        title="video intro"
                                    ></iframe>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-lg-4 ">
                                <iframe
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen
                                    class="lazy entered loaded"
                                    data-src="https://www.youtube.com/embed/7_OhPkg9Wx4"
                                    frameborder="0"
                                    height="450"
                                    scrolling="no"
                                    width="100%"
                                    src="https://www.youtube.com/embed/7_OhPkg9Wx4"
                                    title="video intro"
                                ></iframe>
                            </SwiperSlide>

                            <SwiperSlide className="col-lg-4 ">
                                <iframe
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen
                                    class="lazy entered loaded"
                                    data-src="https://www.youtube.com/embed/Gk_NjLmT1wM"
                                    frameborder="0"
                                    height="450"
                                    scrolling="no"
                                    width="100%"
                                    src="https://www.youtube.com/embed/Gk_NjLmT1wM"
                                    title="video intro"
                                ></iframe>

                            </SwiperSlide>
                            <SwiperSlide className="col-lg-4 ">
                                <iframe
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen
                                    frameborder="0"
                                    height="450"
                                    scrolling="no"
                                    width="100%"
                                    src="https://www.youtube.com/embed/YiBgaCrRZDA"
                                    title="video intro"
                                ></iframe>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </div>

            <div className='certification-section top bottom'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-6'>
                            <div className='certification-item'>
                                <img src="https://www.scnsoft.com/bundles/app/img/financial-times-badge-dark.svg" alt='winklix contact us page' />
                                <img src="https://img.thomascdn.com/badges/shield-tier-v-sm.png?cid=30857224" alt='winklix contact us page' />
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='certification-content'>
                                <h3>In the Spotlight of the IT Industry</h3>
                                <p className='prose-md'>Winklix commitment to service quality and clients’ success is highly praised.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='client-section'>
                <div className='container'>
                    <h2 className='heading1 text-center'>Our Technology Partnerships</h2>
                    <p className='prose-lg'>Throughout our history, we have developed a number of partnerships with technology leaders, who highly attested our technical competencies and the ability to understand our clients’ needs and translate them into quality services:</p>
                    <div className='row top'>
                        <Swiper
                            breakpoints={{
                                425: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                },
                                640: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                },
                                768: {
                                    slidesPerView: 4,
                                    spaceBetween: 30,
                                },
                                1024: {
                                    slidesPerView: 6,
                                    spaceBetween: 30,
                                },
                            }}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            pagination={{
                                clickable: true,
                            }}
                            modules={[Pagination, Autoplay]}
                            className="testimonialSwiper-client"
                        >
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/partner/partner-1.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/partner/partner-2.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/partner/partner-3.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/partner/partner-5.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/partner/partner-8.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/partner/sales-1.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/partner/sales-2.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/partner/sales-3.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/partner/sales-4.webp')} alt='' />
                                </div>
                            </SwiperSlide>

                        </Swiper>
                    </div>
                </div>
            </div>

            <section class="loaction">
                <div class="container">
                    <h2 className='heading1 text-center'>Our Physical Presence</h2>
                    <br />
                    <div class="row mt-30">
                        <div class="col-lg-3 col-sm-4 col-md-3">
                            <div class="location-add">
                                <img src={require('../assets/images/offices/us.webp')} alt='Winklix contact page' />
                                <h2>New York , USA</h2>
                                <p>175 Varick St, New York, NY 10014, United States</p>
                                <b><p>Phone : +1-347-746-2125</p></b>
                                <b><p>Email : sales@winklix.com</p></b>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-4 col-md-3">
                            <div class="location-add">
                                <img src={require('../assets/images/offices/us.webp')} alt='Winklix contact page' />
                                <h2>Wilmington, USA</h2>
                                <p> 919 North Market Street Sute 950 Wilmington De 19801</p>
                                <b><p>Phone : +1-6078386346</p></b>
                                <b><p>Email : sales@winklix.com</p></b>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-4 col-md-3">
                            <div class="location-add">
                                <img src={require('../assets/images/offices/jersy.webp')} alt='Winklix contact page' />
                                <h2>New Jersey , USA</h2>
                                <p>310 , Gorden DR , Paramus , New Jersey , 07652 , USA</p>
                                <b><p>Phone : +1-347-746-2125</p></b>
                                <b><p>Email : sales@winklix.com</p></b>
                            </div>
                        </div>

                        <div class="col-lg-3 col-sm-4 col-md-3">
                            <div class="location-add">
                                <img src={require('../assets/images/offices/landon.webp')} alt='Winklix contact page' />
                                <h2>London , UK</h2>
                                <p>Suite 319, 37 Cremer St, London E2 8HD, United Kingdom</p>
                                <b><p>Phone : +44 74183 43214</p></b>
                                <b><p>Email : sales@winklix.com</p></b>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-4 col-md-3">
                            <div class="location-add">
                                <img src={require('../assets/images/offices/jersy.webp')} alt='Winklix contact page' />
                                <h2>Belgium</h2>
                                <p>Levels 10 & 12, EU Quarter, 5-8 Schuman Roundabout 1040 Brussels, Belgium</p>
                                <b><p>Phone : +1-347-746-2125</p></b>
                                <b><p>Email : sales@winklix.com</p></b>
                            </div>
                        </div>

                        <div class="col-lg-3 col-sm-4 col-md-3">
                            <div class="location-add">
                                <img src={require('../assets/images/offices/india.webp')} alt='Winklix contact page' />
                                <h2>India</h2>
                                <p>Delhi NCR | Mumbai | Pune : HQ : C -430 , Noida Sector 127 , Uttar Pradesh , 201313 , India
                                </p>
                                <b><p>Phone : +91 8882313131</p></b>
                                <b><p>Email : sales@winklix.com</p></b>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-4 col-md-3">
                            <div class="location-add">
                                <img src={require('../assets/images/offices/uae.webp')} alt='Winklix contact page' />
                                <h2>Dubai, UAE</h2>
                                <p>World Trade Center, Sheikh Rashid - Tower
                                    - Level- 24 Sheikh Zayed Rd - Trade Centre
                                    - Trade Centre 2 - Dubai - UAE</p>
                                <b><p>Phone : +1-347-746-2125</p></b>
                                <b><p>Email : sales@winklix.com</p></b>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
